import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Textarea } from '../../components/forms/textarea';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { Text } from '@folio/components/ui/text';

export function CancelStopDialog({
  open,
  onOpenChange,
  title,
  description,
  submitLabel,
  isPending,
  onSubmit,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  submitLabel: string;
  isPending: boolean;
  onSubmit: (comment: string, { onSuccess }: { onSuccess: () => void }) => void;
}) {
  const { t } = useTranslation();
  const [comment, setComment] = useState('');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <Text size="sm" tone="muted">
          {description}
        </Text>
        <Textarea
          aria-label={t('scheduledStop.dialog.reasonLabel')}
          placeholder={t('scheduledStop.dialog.reasonPlaceholder')}
          value={comment}
          onChange={event => setComment(event.target.value)}
        />
        <DialogFooter>
          <Button
            loading={isPending}
            disabled={!comment.trim()}
            onClick={() =>
              onSubmit(comment.trim(), {
                onSuccess: () => {
                  onOpenChange(false);
                  setComment('');
                },
              })
            }
          >
            {submitLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
